export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const CANCEL_NOTIFICATION = 'CANCEL_NOTIFICATION';
